import {http} from '@/http/index.js';

export const getSubscriptions = async () => {
  return http.get('/consumer/subscriptions').then((response) => response.data);
};

export const getMoreSubscriptions = async (url) => {
  return http.get(url).then((response) => response.data);
};
